import { defineAction, number, object, string } from '~/prix'
import polygonInsightAction from './polygonInsight.action.json'

const polygonInsightDefinition = defineAction({
  ...polygonInsightAction,
  input: object({
    agentCpf: string(),
    targetPolygon: string().isOptional(),
    targetRadius: object({
      geolocation: object({
        latitude: number(),
        longitude: number(),
        accuracy: number().isOptional(),
      }),
      radius: number(),
    }).isOptional(),
  }),
  output: object({}),
})

export default polygonInsightDefinition
